
import hiMessages from '../locales/hi_HI';

const HiLang = {
    messages: {
        ...hiMessages
    },
    locale: 'hi-HI',
  
};
export default HiLang;